export { default } from './UploadComponent'
export * from './UploadComponent.interface'
export * from './UploadComponent.styles'
